import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const ContactContainer = styled.div`
  min-height: 100vh;
  padding: 6rem 2rem 4rem;
  background: linear-gradient(135deg, #faf8f5 0%, #f5f0eb 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const Title = styled.h2`
  font-size: clamp(3rem, 6vw, 5rem);
  font-weight: 300;
  color: #d4737d;
  margin: 0 0 2rem 0;
  font-family: 'Playfair Display', serif;
  letter-spacing: -0.02em;
  text-align: center;
`;

const Subtitle = styled.p`
  font-size: clamp(1.2rem, 2.5vw, 1.8rem);
  line-height: 1.6;
  color: #8b6f7d;
  margin: 0 0 4rem 0;
  font-family: 'Cormorant Garamond', serif;
  text-align: center;
  max-width: 600px;
`;

const ContactContent = styled.div`
  display: flex;
  gap: 4rem;
  max-width: 1000px;
  width: 100%;
  align-items: flex-start;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 3rem;
  }
`;

const ContactInfo = styled.div`
  flex: 1;
  text-align: center;
`;

const ContactItem = styled(motion.div)`
  margin-bottom: 2rem;
`;

const ContactLabel = styled.h3`
  font-size: 1.3rem;
  font-weight: 500;
  color: #d4737d;
  margin: 0 0 0.5rem 0;
  font-family: 'Playfair Display', serif;
`;

const ContactValue = styled.p`
  font-size: 1.1rem;
  color: #666;
  margin: 0;
  font-family: 'Cormorant Garamond', serif;
`;

const ContactForm = styled.form`
  flex: 1;
  background: white;
  padding: 3rem;
  border-radius: 25px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);
`;

const FormGroup = styled.div`
  margin-bottom: 2rem;
`;

const SubmitButton = styled(motion.button)`
  background: linear-gradient(135deg, #d4737d 0%, #b85862 100%);
  color: white;
  border: none;
  padding: 1rem 2rem;
  border-radius: 50px;
  font-size: 1.1rem;
  font-weight: 500;
  cursor: pointer;
  font-family: 'Playfair Display', serif;
  width: 100%;
  transition: transform 0.3s ease;
  
  &:hover {
    transform: translateY(-2px);
  }
`;

const Contact = () => {
  const handleMailTo = () => {
    const mailto = `mailto:sauleskodminaite@gmail.com?subject=${encodeURIComponent('Hello from your portfolio')}`;
    window.location.href = mailto;
  };

  return (
    <ContactContainer id="contact">
      <Title>Let's Work Together</Title>
      <Subtitle>
        Ready to create something beautiful? I'd love to hear about your project 
        and discuss how we can bring your vision to life.
      </Subtitle>
      
      <ContactContent>
        <ContactInfo>
          <ContactItem
            initial={{ x: -50, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <ContactLabel>Email</ContactLabel>
            <ContactValue>sauleskodminaite@gmail.com</ContactValue>
          </ContactItem>
          
          <ContactItem
            initial={{ x: -50, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            viewport={{ once: true }}
          >
            <ContactLabel>Phone</ContactLabel>
            <ContactValue>+370 (609) 88 576</ContactValue>
          </ContactItem>
          
          <ContactItem
            initial={{ x: -50, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <ContactLabel>Based in</ContactLabel>
            <ContactValue>Utrecht, NL</ContactValue>
          </ContactItem>
        </ContactInfo>
        
        <motion.div
          initial={{ x: 50, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          viewport={{ once: true }}
        >
          <ContactForm as="div">
            <FormGroup>
              <SubmitButton
                type="button"
                onClick={handleMailTo}
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
              >
                Send Message
              </SubmitButton>
            </FormGroup>
          </ContactForm>
        </motion.div>
      </ContactContent>
    </ContactContainer>
  );
};

export default Contact;